import RegisterCompleted from './RegisterCompleted';

export default RegisterCompleted;